export enum AdditionCodes {
  // CustomerPower = 'T-KUNDEFF', // -> CustomerDayPower = 'T-DYGNEFF' (2025)
  PrePaid = 'T-FÖRSKOTT',
  HourEffect = 'T-UTTIMEFF',
  YearlyMax = 'T-ÅRSKTAK',
  ClimateNeutral = 'T-KLIMATN',
  EnvCert = 'T-MILJÖCER',
  Invest60 = 'Fjärrvärme INVEST 60',
  Invest120 = 'Fjärrvärme INVEST 120 månader',
  Driftnetto = 'T-DRFTNETO',
  // FJV25
  CustomerDayPower = 'T-DYGNEFF',
  EnvRep = 'T-MILJÖRED'
}
